import type { LocalizedText } from "@/shared/api/types";

/** Locales editors translate content into (vi is required). */
export const UI_LOCALES = ["vi", "en"] as const;

/** Resolves localized text with the same fallback as the API: vi → en → any. */
export function t(text: LocalizedText | undefined, locale = "vi"): string {
  if (!text) return "";
  return text[locale] || text.vi || text.en || Object.values(text).find(Boolean) || "";
}

const dateFmt = new Intl.DateTimeFormat("vi-VN", { dateStyle: "medium", timeStyle: "short" });

export const formatDate = (iso: string | null | undefined) => (iso ? dateFmt.format(new Date(iso)) : "—");

export const percent = (v: number) => `${Math.round(v * 100)}%`;

/** Meter tone for a 0–1 accuracy: ≥ 80% good, ≥ 50% so-so, else poor. */
export const accuracyTone = (v: number) => (v >= 0.8 ? "success" : v >= 0.5 ? "warning" : "danger");

export function duration(ms: number) {
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${s % 60}s`;
  return `${Math.floor(m / 60)}h ${m % 60}m`;
}

export const slugify = (s: string) =>
  s
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/đ/gi, "d")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
